import resetForm from './resetForm';
import setIsNewRecord from './setIsNewRecord';
import toggleModalProduct from './toggleModalProduct';

export default () => (dispatch) => {
    dispatch(resetForm());
    dispatch(setIsNewRecord(true));
    dispatch(toggleModalProduct(true));
};
